<template>
  <div class="pms-search-item" :class="{ vertical: !isZh }">
    <label class="label">{{ label }}</label>
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PmsSearchItem',
  props: {
    label: String,
  },
  computed: {
    isZh() {
      return this.$i18n.locale.includes('zh');
    },
  },
};
</script>

<style lang="scss" scoped>
.pms-search-item {
  width: 100%;
  display: flex;
  align-items: center;
  .label {
    width: 60px;
    text-align: right;
    margin-right: 12px;
    white-space: nowrap;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
  }

  .content {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
  }
  .content > * {
    flex: 1 1 auto;
    min-width: 0;
  }
  .divide-line {
    flex: 0 0 auto;
    width: 12px;
    text-align: center;
    opacity: 0.6;
    align-self: center;
  }
  &.vertical {
    flex-direction: column;
    align-items: flex-start;

    .label {
      width: auto;
      margin-bottom: 6px;
      text-align: left;
    }
    .content {
      width: 100%;
    }
  }
}
</style>
